import { VehicleState } from './types'
import { AsyncStateStatus } from '../root.types'
import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit'

const initialState: VehicleState = {
    request: {
        status: AsyncStateStatus.INITIAL,
        data: []
    }
}

export const vehiclesSlice = createSlice({
    name: '@vehicles',
    initialState,
    reducers: {
        vehiclesRequest: (state: Draft<VehicleState>) => {
            state.request.status = AsyncStateStatus.LOADING
        },
        vehiclesSuccess: (state: Draft<VehicleState>,  action: PayloadAction<{ data: any }>) => {
            state.request.status = AsyncStateStatus.SUCCESS
            state.request.data = action.payload.data
        },
        vehiclesFailure: (state: Draft<VehicleState>) => {
            state.request.status = AsyncStateStatus.FAILURE
            state.request.data = []
        },
        vehiclesCancel: (state: Draft<VehicleState>) => {
            state.request.status = AsyncStateStatus.INITIAL
            state.request.data = []
        },
    }
})

/**
 * <h5>Functions that trigger actions related to authentication in the system.</h5>
 * @see {@link https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers#designing-actions}
 * @typedef VehiclesActions
 * @namespace VehiclesActions
 * @category React
 * @subcategory Redux / Actions
 * @property {Function} vehiclesRequest
 * @property {Function} vehiclesSuccess
 * @property {Function} vehiclesFailure
 */
export const VehiclesActions = vehiclesSlice.actions

export default vehiclesSlice.reducer
